import * as React from 'react';

export const Right = ({ ...props }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="24"
        viewBox="0 0 16 24"
        fill="none"
        {...props}
    >
        <path
            d="M7.56183 18L12.5 12.6522L1 12.6522L1 11.3261L12.5 11.3261L7.56183 6L9.35726 6L15 12L9.35725 18L7.56183 18Z"
            fill="currentColor"
        />
    </svg>
);

export default Right;
